import React, { Component } from 'react';
import styled from 'styled-components';

class Checkbox extends Component<any, any> {
  render() {
    return (
      <Styled
        onClick={
          this.props.onChange
            ? () => this.props.onChange(!this.props.checked)
            : undefined
        }
      >
        <input
          aria-label="checkbox"
          type="checkbox"
          onChange={() => console.log('check')}
          checked={this.props.checked}
        />
        <label>{this.props.label}</label>
      </Styled>
    );
  }
}

export default Checkbox;

const Styled = styled.div`
  @media (max-width: 480px) {
    margin-right: 0;
  }
  /* display: inline-block; */
  > input {
    opacity: 0;
    width: 0;
  }
  > input + label {
    position: relative; /* permet de positionner les pseudo-éléments */
    padding-left: 25px; /* fait un peu d'espace pour notre case à venir */
    cursor: pointer; /* affiche un curseur adapté */
    &:before {
      content: '';
      position: absolute;
      left: 2px;
      top: 2px;
      width: 16px;
      /* padding-top: 7px; */
      height: 16px;
      border: 1px solid #c4cdd5;
      background: #ffffff;
      border-radius: 3px;
    }
    &:after {
      content: '✔';
      position: absolute;
      top: 2px;
      left: 2px;
      padding-left: 2px;
      width: 18px;
      font-size: 15px;
      color: #fff;
      background: #7a55a5;
      -webkit-transition: all 0.2s;
      -webkit-transition: all 0.2s;
      transition: all 0.2s;
    }
  }
  > input:not(:checked) + label {
    &:after {
      opacity: 0; /* coche invisible */
      transform: scale(0); /* mise à l'échelle à 0 */
    }
  }
  > input:disabled:not(:checked) + label {
    &:before {
      box-shadow: none;
      border-color: #bbb;
      background-color: #ddd;
    }
  }
  > input:checked + label {
    &:after {
      opacity: 1; /* coche opaque */
      transform: scale(1); /* mise à l'échelle 1:1 */
    }
  }
  > input:disabled:checked + label {
    &:after {
      color: #999;
    }
  }
  > input:disabled + label {
    color: #aaa;
  }
  > input:checked:focus + label,
  input:not(:checked):focus + label {
    &:before {
      border: 1px dotted blue;
    }
  }
`;
